<template>
<div>
  <el-table :data="tableData"
            border default-expand-all stripe
            :header-cell-style="{'text-align':'center'}"
            cell-style="{'text-align':'center'}"
            style="width: 100%;margin-bottom: 20px;"
            class="tb-edit"
            highlight-current-row
            @row-click="handleCurrentChange">
    <el-table-column prop="id" label="序号">
    <template slot-scope="scope">
      <span>{{scope.$index + 1}}</span>
    </template>
    </el-table-column>
    <el-table-column label="价格区间">
    <el-table-column label="起(不含)">
      <template slot-scope="scope">
        <el-input type="number" size="small" v-model="scope.row.startPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.startPrice}}</span>
      </template>
    </el-table-column>
      <el-table-column label="止(包含)">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.endPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.endPrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="立返">
      <el-table-column label="服务费">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.backupServicePrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.backupServicePrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="佣金">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.backupCommissionPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.backupCommissionPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="显示服务费">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.backupShowSerPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.backupShowSerPrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="货返">
      <el-table-column label="服务费">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.goodReturnServicePrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.goodReturnServicePrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="佣金">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.goodReturnCommissionPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.goodReturnCommissionPrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="级别抽佣">
      <el-table-column label="一级">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.oneChargesPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.oneChargesPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="二级">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.twoChargesPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.twoChargesPrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="操作">
      <template slot-scope="scope">
        <!--<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
        <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
        <span v-if="scope.row.id == ''" style="margin-left: 10%;">
          <el-button type="primary" icon="el-icon-upload" circle @click="handleSave(scope.$index, scope.row)">
          </el-button>
        </span>
      </template>
    </el-table-column>
  </el-table>
  <el-button type="primary" icon="el-icon-plus" circle @click="addTableData"></el-button>
  <el-pagination
      :page-sizes="[20, 50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="pagination.pageNum"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      @size-change="handlePageSizeChange"
      @current-change="handlePageNumChange"
      background
      style="float: right;margin-bottom: 10px">
  </el-pagination>
</div>
</template>

<script>
import {getCustoMoneySetting, addCustoMoneySetting, updateCustoMoneySetting, deleteCustoMoneySetting} from "../api/b2cbusiness/b2c_customoneysetting";

export default {
  name: "MoneyTableData",
  props: ['selectMenuValue'],
  data(){
    return {
      selectMenuValue:this.selectMenuValue,
      tableData: [
      ],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  watch:{
    selectMenuValue(val){
      //console.log("---fdfdfdfdfddfd--", this.selectMenuValue);
      this.selectMenuValue = val;
      getCustoMoneySetting({cmsettingId:0, b2cTaskTypeId:this.selectMenuValue.id, startPrice:0, endPrice:0}, this.pagination).then(
          res => {
            console.log(res.data);
            if (res.success){
              this.tableData = res.data.records;
              this.pagination.pageNum = res.data.current;
              this.pagination.pageSize = res.data.size;
              this.pagination.total = res.data.total;
            }
          }
      );
    }
  },
  mounted() {
    getCustoMoneySetting({cmsettingId:0, b2cTaskTypeId:this.selectMenuValue.id, startPrice:0, endPrice:0}, this.pagination).then(
        res => {
           console.log(res.data);
           if (res.success){
             this.tableData = res.data.records;
             this.pagination.pageNum = res.data.current;
             this.pagination.pageSize = res.data.size;
             this.pagination.total = res.data.total;
           }
        }
    );
  },
  methods:{
    getData(){
      getCustoMoneySetting({cmsettingId:0, b2cTaskTypeId:this.selectMenuValue.id, startPrice:0, endPrice:0}, this.pagination).then(
          res => {
            console.log(res.data);
            if (res.success){
              this.tableData = res.data.records;
              this.pagination.pageNum = res.data.current;
              this.pagination.pageSize = res.data.size;
              this.pagination.total = res.data.total;
            }
          }
      );
    },
    handleCurrentChange(row, event, column) {
      console.log(row, event, column, event.currentTarget)
    },
    handleEdit(index, row) {
      console.log(index, row);
      updateCustoMoneySetting(row).then(res => {
        console.log(res.data);
        if (res.success){
          this.getData();
        }
      });
    },
    handleDelete(index, row) {
      console.log(index, row);
      deleteCustoMoneySetting(row.id).then(res => {
        console.log(res.data);
        if (res.success){
          this.getData();
        }
      });
    },
    handleSave(index, row){
      row.b2cTaskTypeId = this.selectMenuValue.id;
      console.log("_+_+_+_+_+_+", index, row);
      addCustoMoneySetting(row).then(
          res => {
            console.log(res.data);
            if (res.success){
              this.getData();
            }
          }
      );
    },
    addTableData(){
      this.tableData.push({
        id: "",
        b2cTaskTypeId: this.selectMenuValue.b2cTaskTypeId,
        startPrice: 0,
        endPrice: 50,
        backupCommissionPrice: 3,
        backupServicePrice: 8,
        backupShowSerPrice: 0,
        goodReturnCommissionPrice: 1,
        goodReturnServicePrice: 1,
        oneChargesPrice: 0,
        twoChargesPrice: 0,
        remarks: null
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData();
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      getCustoMoneySetting({cmsettingId:0, b2cTaskTypeId:this.selectMenuValue.id, startPrice:0, endPrice:0}, this.pagination).then(
          res => {
            console.log(res.data);
            if (res.success){
              this.tableData = res.data.records;
              this.pagination.pageNum = res.data.current;
              this.pagination.pageSize = res.data.size;
              this.pagination.total = res.data.total;
            }
          }
      );
    },
  }
}
</script>

<style scoped>
/deep/.el-table th > .cell {
  text-align: center;
}
/deep/.el-table .cell {
  text-align: center;
}
span{
  text-align: center;
}
.tb-edit .el-input {
  display: none
}
.tb-edit .current-row .el-input {
  display: block
}
.tb-edit .current-row .el-input+span {
  display: none
}
</style>
